<template>
  <div id="rg-object-history-player" v-if="showRgHistoryPlayer">
    <rg-object-history-map
      v-if="isSetUpFinished"
      mapId="rg-object-history-player-map"
      :mapSetting="mapSetting"
      :mapStyle="mapStyle"
      :updateMapStyle="updateMapStyle"
      :textLayerIds="textLayerIds"
      :mapLocale="mapLocale"
      :playbackRequestSettings="playbackRequestSettings"
    ></rg-object-history-map>
  </div>
</template>

<script>
import {
  MAP_DEFAULT_POSITION,
  MAP_STYLE_DEFAULT,
  MAP_STYLE_SATELLITE,
} from "@/config/const";

import LocalDbService from "@/services/localDbService";
import FireStoreService from "@/services/fireStoreService";
import C from "./Constants";
import { LocalizeMixin, DeviceInfoMixin } from "@/mixins";
// components
import RgObjectHistoryMap from "./RgObjectHistoryMap.vue";
import rgPlayBackService from "@/services/rgPlayBackService";

export default {
  name: "RgObjectHistoryPlayer",
  mixins: [LocalizeMixin, DeviceInfoMixin],
  components: { RgObjectHistoryMap },
  data() {
    return {
      isSetUpFinished: false,
      mapStyle: "",
      pos: null,
    };
  },
  computed: {
    currentQueryParams() {
      return this.$route.query;
    },
    playbackRequestSettings() {
      return rgPlayBackService.createRgPlaybackSettings(
        this.currentQueryParams
      );
    },
    isSpecifyAreaValid() {
      return this.playbackRequestSettings.isAreaValid();
    },
    showRgHistoryPlayer() {
      return this.isSetUpFinished;
    },
    mapSetting() {
      if (!this.isSpecifyAreaValid) return {};
      const center = this.playbackRequestSettings.calcCenterOfMass().geometry
        .coordinates;
      return {
        container: "rg-object-history-player-map",
        style: this.mapStyle,
        center: center,
        zoom: C.PLAYBACK_AREA_DEFAULT_ZOOM,
        doubleClickZoom: false,
        maxZoom: 18,
        attributionControl: false,
        localIdeographFontFamily: "'Noto Sans', sans-serif",
      };
    },
    mapZoom() {
      if (!this.pos) return MAP_DEFAULT_POSITION.zoom;
      if (!this.pos.zoom) return MAP_DEFAULT_POSITION.zoom;
      return this.pos.zoom;
    },
    textLayerIds() {
      return this.getTextLayerIds();
    },
    mapLocale() {
      return "name_" + this.getBrowserLanguage();
    },
  },
  methods: {
    async setUp() {
      if (!this.isSpecifyAreaValid) return false;
      this.mapStyle = await LocalDbService.getMapStyle();
      this.pos = await LocalDbService.getDefaultPosition();
      return true;
    },
    setRouterViewStyle() {
      const routerViewClass = document.getElementsByClassName("router-view");
      const prevCssText = routerViewClass[0].cssText;
      routerViewClass[0].style.setProperty("padding", "0.0rem", "important");
      return prevCssText;
    },
    updateMapStyle() {
      if (this.mapStyle === MAP_STYLE_DEFAULT) {
        this.mapStyle = MAP_STYLE_SATELLITE;
        FireStoreService.saveMapStyle(MAP_STYLE_SATELLITE);
        LocalDbService.saveMapStyle(MAP_STYLE_SATELLITE);
      } else {
        this.mapStyle = MAP_STYLE_DEFAULT;
        FireStoreService.saveMapStyle(MAP_STYLE_DEFAULT);
        LocalDbService.saveMapStyle(MAP_STYLE_DEFAULT);
      }
    },
  },
  async created() {
    this.isSetUpFinished = await this.setUp();
  },
  beforeRouteEnter(_to, _from, next) {
    next(vm => {
      if (!vm.isSpecifyAreaValid) {
        // area指定が不正ならば、live-mapに遷移
        return vm.playbackRequestSettings.toDefaultMap(vm.$router);
      }
    });
  },
};
</script>

<style lang="scss">
.router-view {
  &:has(#rg-object-history-player) {
    padding: 0rem !important;
  }
}
</style>
